import { createFileRoute } from "@tanstack/react-router";
import { VendorCheckInPage } from "@/components/vendor/check-in/VendorCheckInPage";

export const Route = createFileRoute("/vendor/check-in")({
  head: () => ({ meta: [{ title: "QR Check-in · Venue Portal" }] }),
  component: VendorCheckInPage,
});
